import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';

const {
    LINK_TRACKING_EVENT,
    PAGE_TYPES: { USER_PROFILE },
    PAGE_NAMES: { BI_SIGNED_IN, BI_ANONYMOUS }
} = anaConsts;

function setPageLoadAnalytics(isUserAtleastRecognized) {
    digitalData.page.category.pageType = USER_PROFILE;
    digitalData.page.pageInfo.pageName = isUserAtleastRecognized ? BI_SIGNED_IN : BI_ANONYMOUS;
}

function fireLinkTracking(actionInfo) {
    processEvent.process(LINK_TRACKING_EVENT, {
        data: {
            actionInfo
        }
    });
}

function getLocationType(record) {
    if (record?.groupType === 'NON_ORDER') {
        return 'other';
    }

    const groupDescLower = (record?.groupDescription || '').toLowerCase();

    // Treat records with a digitalOrderId or a Sephora.com group description as online purchases
    if (record?.digitalOrderId || groupDescLower.includes('sephora.com')) {
        return 'online';
    }

    // Default to store for in-store purchases
    return 'store';
}

function getActivityType(record) {
    // Check order status first
    const orderStatusCode = (record?.orderStatusCode || '').toLowerCase();

    if (orderStatusCode === 'canceled') {
        return 'cancelled';
    }

    if (orderStatusCode === 'returned') {
        return 'returned';
    }

    // Determine based on points
    if (record?.netGroupPoints > 0) {
        return 'earn';
    }

    return 'burn';
}

function firePointsActivityExpandAnalytics(record) {
    const locationType = getLocationType(record);
    const activityType = getActivityType(record);

    const actionInfo = `points activity:${locationType}:${activityType}`;

    processEvent.process(LINK_TRACKING_EVENT, {
        data: {
            actionInfo //prop55
        }
    });
}

export default { setPageLoadAnalytics, fireLinkTracking, firePointsActivityExpandAnalytics };
